import React, { Component } from 'react'
import { Button, Dimmer, Icon, Loader, Table, Visibility } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { getApiData } from 'helpers/api'
import { DATASOURCE } from 'Constants'
import { convertToCsv, downloadFile, ListHeaderMap } from 'helpers/download_helper'
import { translate } from 'react-i18next'
import qs from 'query-string'
import FilterBar from './FilterBar'

class CallList extends Component {

  constructor(props) {
    super(props);

    let params = {};
    if (this.props.location.search) {
      params = qs.parse(this.props.location.search);
    }
    let sortAsc = params.sortOrder ? params.sortOrder.toLowerCase() !== "desc" : false;

    this.state = {
      rowsDisplayed: 20,
      filterHidden: true,
      sortAscending: sortAsc
    };

    this.getAllData = this.getAllData.bind(this);
    this.getCallDetails = this.getCallDetails.bind(this);
    this.getBookmarkParameter = this.getBookmarkParameter.bind(this);
  }

  pageSize = 20;

  myUrl = this.props.location.pathname.replace(this.props.location.search,'');

  componentDidMount() {
    getApiData(DATASOURCE.CALLSREFRESH, this.props.location.search);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      getApiData(DATASOURCE.CALLSREFRESH, this.props.location.search);
    }
  }

  getCallDetails(callId) {
    let myUrl = this.props.location.pathname.replace(this.props.location.search,'');
    let params = {};
    if (this.props.location.search) {
      params = qs.parse(this.props.location.search);
    }
    params["callId"] = callId;
    this.props.history.push(myUrl + "/CallDetail?" + qs.stringify(params));
  }

  getBookmarkParameter(bookmark) {
    let params = {};
    if (this.props.location.search) {
      params = qs.parse(this.props.location.search);
    }
    let ret = null;
    if (params["sortOrder"] && params["sortOrder"].toLowerCase() === "asc") {
      ret = {searchAfter:bookmark};
    } else {
      ret = {searchBefore:bookmark};
    }
    return ret;
  }

  getAllData() {
    if (this.props.totalCalls > 0 && this.props.calls.length < this.props.totalCalls) {
      getApiData(DATASOURCE.CALLSREFRESH,this.props.location.search,{limit:this.props.totalCalls});
    }
  }

  changeSortOrder() {
    let sortAsc = this.state.sortAscending;
    let myUrl = this.props.location.pathname.replace(this.props.location.search,'');
    let params = {};
    if (this.props.location.search) {
      params = qs.parse(this.props.location.search);
    }
    if (sortAsc) {
      delete(params.sortOrder);
    } else {
      params.sortOrder = "asc";
    }
    this.setState({sortAscending: !sortAsc});
    this.props.history.push(myUrl + "?" + qs.stringify(params));
  }

  // TODO - add table sorting when clicking the header columns. Sorting applied as query parameter
  render() {
    let isFullData = this.props.calls.length === this.props.totalCalls;
    const { t } = this.props;
    return (
      <div style={{width: '100%'}}>
        <Button title={t("Screens.Calls.List.FilterBar.Title")} onClick={() => {
          this.setState({filterHidden: !this.state.filterHidden});
        }}>
          {this.state.filterHidden ? 
            t("Screens.Calls.List.FilterBar.Show") : t("Screens.Calls.List.FilterBar.Hide")}
        </Button>
        <Button title={t("Screens.Calls.List.ChangeSort")} onClick={() => {
          this.changeSortOrder();
        }}>
          {this.state.sortAscending ? t("Screens.Calls.List.SortDesc") : t("Screens.Calls.List.SortAsc")}
        </Button>
          
        <FilterBar filterHidden={this.state.filterHidden} {...this.props}/>
        <Button 
          title={isFullData ? t("Screens.Calls.List.DLCSVFULL") : t("Screens.Calls.List.DLCSV")} 
          style={{float: 'right'}}
          onClick={() => {
            let csv = convertToCsv(this.props.calls, t);
            downloadFile(csv,"export.csv","application/csv")
          }}
        >
          <Icon name="download" />
          {t("Screens.Calls.List.CSV")} 
        </Button>
        <Button 
          title={isFullData ? t("Screens.Calls.List.DLJSONFULL") : t("Screens.Calls.List.DLJSON")} 
          style={{float: 'right'}}
          onClick={() => {
            downloadFile(JSON.stringify(this.props.calls,null,2),"export.json","application/json")
          }}
        >
          <Icon name="download" />
          {t("Screens.Calls.List.JSON")}
        </Button>
        { !isFullData && this.props.totalCalls > 0 && this.props.totalCalls <= 10000 &&
            <Button title={t("Screens.Calls.List.GETDATATITLE")} style={{float: 'right'}}
              onClick={() => {
                this.getAllData();
              }}
            >
              {t("Screens.Calls.List.GETDATA")}
            </Button>
        }
        <p style={{float: 'right', height: '32px', lineHeight: '32px', margin: '0 10px 0 0'}}>
          {this.props.calls.length} / {this.props.totalCalls} calls loaded 
          {this.props.totalCalls > 10000 ? " (Can't bulk load more than 10k)" : ""}
        </p>
        <div className="scrollableView" style={{clear: 'both'}}>
          <div className="ui blurring basic segment">
            <Table celled compact size="small">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{t("Screens.Calls.List.Link")}</Table.HeaderCell>
                  {ListHeaderMap.map((entry,index) => {
                    if (entry.title) {
                      return(
                        <Table.HeaderCell key={index}>{t(entry.trans)}
                          <Icon name="mouse pointer" title={t(entry.titleTrans)} />
                        </Table.HeaderCell>
                      );
                    }
                    return (
                      <Table.HeaderCell key={index}>{t(entry.trans)}</Table.HeaderCell>
                    );
                  })}
                </Table.Row>
              </Table.Header>

              <Visibility 
                as="tbody"
                continuous={false}
                once={false}
                onBottomVisible={() => {
                  if (this.state.rowsDisplayed + this.pageSize <= this.props.calls.length) {
                    this.setState({rowsDisplayed: this.state.rowsDisplayed + this.pageSize});
                  } else if (this.props.calls.length === this.props.totalCalls) {
                    if (this.state.rowsDisplayed !== this.props.calls.length) {
                      this.setState({rowsDisplayed: this.props.calls.length === 0 ? 20 : this.props.calls.length});
                    }
                  } else {
                    // need more data
                    let bookmark = this.props.calls[this.props.calls.length-1].bookmark;
                    
                    getApiData(DATASOURCE.CALLSUPDATE,this.props.location.search,this.getBookmarkParameter(bookmark));
                    if (this.state.rowsDisplayed + this.pageSize <= this.props.totalCalls) {
                      this.setState({rowsDisplayed: this.state.rowsDisplayed + this.pageSize});
                    } else {
                      this.setState({rowsDisplayed: this.props.totalCalls});
                    }
                  }
                }}
              >
                {this.props.calls.map((entry, index) => {
                  if (index < this.state.rowsDisplayed) {
                    return (
                      <Table.Row key={index}>
                        <Table.Cell>
                          <Button icon onClick={() => this.getCallDetails(entry.callId)}>
                            <Icon name="linkify" title="Get this call"/>
                          </Button>
                        </Table.Cell>
                        {ListHeaderMap.map((data,index) => {
                          if (data.title) {
                            return (
                              <Table.Cell key={index} title={entry[data.title]}>{entry[data.data]}</Table.Cell>
                            );
                          }
                          return (
                            <Table.Cell key={index}>{entry[data.data]}</Table.Cell>
                          );
                        })}
                      </Table.Row>
                    )
                  } else {
                    return null;
                  }
                })}
              </Visibility>
            </Table>
            <Dimmer active={this.props.loading} inverted>
              <Loader />
            </Dimmer>
          </div>
        </div>
      </div>
    )
  }

}

// REDUX STATE
const mapToProps = state => {
  return {
    calls: state.calls.data,
    loading: state.calls.loading,
    totalCalls: state.calls.total
  }
};

export default translate()(
  connect(
    mapToProps,
    null
  )(CallList)
);
